export default "__VITE_ASSET__D8jHM0Rw__"